import Vue from "vue";
import swal from "sweetalert";
Vue.$swal = swal;
